import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSafetyCallFirefighters1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_386_8119)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M3.12138 10.9081L3.11071 10.9188C2.07431 11.8072 1.37184 13.0224 1.11925 14.3639C0.866657 15.7054 1.07906 17.0929 1.72138 18.2974L2.28005 19.3454C2.40372 19.5772 2.57184 19.7823 2.7748 19.9491C2.97777 20.1159 3.21161 20.2411 3.46296 20.3175C3.71431 20.3939 3.97825 20.42 4.2397 20.3944C4.50115 20.3687 4.75498 20.2918 4.98671 20.1681L9.39738 17.8148C9.86535 17.5652 10.215 17.14 10.3696 16.6327C10.5241 16.1254 10.4708 15.5775 10.2214 15.1094C10.0972 14.8776 10.02 14.6235 9.99414 14.3618C9.96829 14.1 9.99432 13.8358 10.0707 13.5841C10.1472 13.3325 10.2725 13.0983 10.4395 12.8952C10.6065 12.692 10.8119 12.5238 11.044 12.4001L18.1027 8.63476C18.5706 8.38525 19.1184 8.33175 19.6257 8.48602C20.133 8.64029 20.5583 8.98969 20.808 9.45743C20.9316 9.68931 21.0996 9.89458 21.3026 10.0615C21.5055 10.2284 21.7393 10.3537 21.9906 10.4302C22.242 10.5068 22.506 10.533 22.7675 10.5075C23.029 10.4819 23.2829 10.4051 23.5147 10.2814L27.9254 7.92676C28.3933 7.67723 28.743 7.25204 28.8976 6.74472C29.0521 6.23739 28.9988 5.68946 28.7494 5.22143L28.1907 4.17343C27.5477 2.96941 26.5133 2.02063 25.2584 1.4837C24.0035 0.946771 22.603 0.853786 21.288 1.22009H21.2734C14.6593 3.25996 8.49746 6.54862 3.12138 10.9081Z",
			stroke: "#EB6A1E",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M24.9844 31C21.9844 31 18.9844 28.6973 18.9844 25.8573C18.9844 22.772 20.3337 20.7147 22.5844 20.7147C22.2844 22.4293 22.1337 23.8 23.9337 23.8C26.6337 23.8 25.851 18.744 22.9844 15C26.7177 15 30.9844 19.8573 30.9844 24.1427C30.9844 27.572 29.3324 31 24.9844 31Z",
			stroke: "#EB6A1E",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_386_8119",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgSafetyCallFirefighters1;
